import { ModeEnum as e } from "../core/models/model.js";
import { DatePicker as t } from "../ui/index.js";
import { CalendarPickerBody as n } from "./calendar-picker.js";
import { toLocalDateFromUtc as r, toUtcFromLocalDate as i } from "../utilities/utc.js";
import { cn as a } from "../../../cn.js";
import { FormErrorText as o, FormHelperText as s, FormLabel as c } from "../../shared/form-primitives.js";
import { useId as l } from "react";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
import { When as f } from "react-if";
import { Field as p } from "@ark-ui/react/field";
// src/design/forms/datepicker/composed/calendar-field.tsx
var m = (t) => {
	let n = t;
	return n === e.RANGE || n === "range" ? e.RANGE : n === e.WEEK || n === "week" ? e.WEEK : e.SINGLE;
}, h = (h) => {
	let { label: g, helperText: _, errorText: v, required: y, mode: b = e.SINGLE, onChange: x, disableDateBefore: S, disableDateAfter: C, disabledWeekDays: w, holidays: T, disabled: E = !1, className: D, value: O, invalid: k = !1, variant: A = "filter", isUtc: j = !1, "aria-label": M, clearable: N, ...P } = h, F = l(), I = {
		label: `${F}-label`,
		helperText: `${F}-helper`,
		errorText: `${F}-error`
	}, L = m(b), R = !!v || k, z = typeof O == "object" ? O.startDate : O, B = typeof O == "object" ? O.endDate : void 0, V = j ? r(z) : z, H = j ? r(B) : B;
	return /* @__PURE__ */ d(p.Root, {
		className: a("flex flex-col gap-1", D),
		invalid: R,
		required: y,
		disabled: E,
		ids: I,
		children: [
			/* @__PURE__ */ u(f, {
				condition: !!g,
				children: /* @__PURE__ */ u(c, {
					required: y,
					disabled: E,
					children: g
				})
			}),
			/* @__PURE__ */ u(t, {
				mode: L,
				disableDateBefore: S,
				disableDateAfter: C,
				disabledWeekDays: w,
				holidays: T,
				onChange: (e) => {
					x && x(j ? typeof e == "object" ? {
						startDate: i(e.startDate),
						endDate: i(e.endDate)
					} : i(e) : e);
				},
				isDisabled: E,
				startDate: V,
				endDate: H,
				...P,
				children: /* @__PURE__ */ u(n, {
					variant: A,
					clearable: N,
					group: {
						"aria-labelledby": g ? I.label : void 0,
						"aria-label": g ? void 0 : M,
						"aria-describedby": v ? I.errorText : _ ? I.helperText : void 0,
						"aria-invalid": R || void 0
					}
				})
			}),
			/* @__PURE__ */ u(f, {
				condition: _ && !v,
				children: /* @__PURE__ */ u(s, { children: _ })
			}),
			/* @__PURE__ */ u(f, {
				condition: v,
				children: /* @__PURE__ */ u(o, { children: v })
			})
		]
	});
}, g = Object.assign(h, {
	Default: h,
	Root: ({ children: e, className: t, ...n }) => /* @__PURE__ */ u(p.Root, {
		className: a("flex flex-col gap-0.5", t),
		...n,
		children: e
	}),
	Label: ({ children: e, ...t }) => /* @__PURE__ */ u(c, {
		...t,
		children: e
	}),
	DatePickerInput: ({ mode: r = e.SINGLE, onChange: i, disableDateBefore: a, disableDateAfter: o, disabledWeekDays: s, holidays: c, disabled: l = !1 }) => {
		let d = m(r);
		return /* @__PURE__ */ u(t, {
			mode: d,
			disableDateBefore: a,
			disableDateAfter: o,
			disabledWeekDays: s,
			holidays: c,
			onChange: i,
			isDisabled: l,
			children: /* @__PURE__ */ u(n, {})
		});
	},
	HelperText: ({ children: e, ...t }) => /* @__PURE__ */ u(s, {
		...t,
		children: e
	}),
	ErrorText: ({ children: e, ...t }) => /* @__PURE__ */ u(o, {
		...t,
		children: e
	}),
	RequiredIndicator: ({ children: e, className: t, ...n }) => /* @__PURE__ */ u(p.RequiredIndicator, {
		className: a("text-destructive ml-0.5", t),
		...n,
		children: e ?? "*"
	})
});
export { g as DatePickerField };

//# sourceMappingURL=calendar-field.js.map